import { createProductPreviewScene } from './productPreviewScene';

// Session-only cache: reuse rendered images across scene/route remounts, never CAD sheets.
const renderCache = new Map();
const cacheKey = p => JSON.stringify([p.id,p.kind,p.width,p.height,p.panel_count,p.track_count,!!p.has_screen,!!p.pocket]);

/** Render every model, even when its catalogue record has a source drawing. */
export function scheduleThumbnails(allProducts, library, onUpdate, shouldPause = () => false, priorityId = () => null) {
  let cancelled = false, timer = null, preview = null;
  const images = Object.fromEntries(allProducts.filter(p => renderCache.has(cacheKey(p))).map(p => [p.id,renderCache.get(cacheKey(p))]));
  const products = allProducts.filter(p => !images[p.id]).sort((a,b) =>
    Number(a.roomFamily?.default_product_id !== a.id) - Number(b.roomFamily?.default_product_id !== b.id));
  const attempts = new Map();
  onUpdate({ ...images });
  const release = () => { preview?.dispose(); preview = null; };
  const next = async () => {
    if (cancelled || !products.length) return;
    if (shouldPause()) { timer = setTimeout(next, 400); return; }
    // Render the product currently on screen before the rest of the catalog.
    const priority = products.findIndex(product => product.id === priorityId());
    const product = products.splice(priority < 0 ? 0 : priority, 1)[0];
    try {
      preview ??= createProductPreviewScene(library);
      const src = await preview.render(product);
      if (!cancelled) {
        renderCache.set(cacheKey(product), src); images[product.id] = src;
        onUpdate({ ...images });
      }
    } catch (error) {
      if (!cancelled) {
        const count = (attempts.get(product.id) || 0) + 1; attempts.set(product.id,count);
        if (count < 2) products.push(product);
        else { images[product.id] = null; onUpdate({ ...images }); console.error(`Product preview failed: ${product.id}`,error); }
      }
    }
    if (cancelled) return;
    if (products.length) timer = setTimeout(next, 300);
    else release();
  };
  if (products.length) timer = setTimeout(next, 600);
  return () => { cancelled = true; clearTimeout(timer); release(); };
}